import clsx from 'clsx';
import { useMemo } from 'react';
import { useBenhAnContext } from '../../../../contexts/BenhAnContext';
import PhieuTemplate from '../../shared/PhieuTemplate';
import {LOAI_BENH_AN} from "../../../../constants/BenhAn";
import {parseJSON} from "../../../../../utils/FormatUtils";
import {COMPONENT_TYPE} from "../../../../../utils/Constant";
import {ComponentMapper, ComponentTypeListMapper} from "./ComponentMapper";

type Props = {
  disabled?: boolean;
};

const ThongTinBenhAn = ({ disabled }: Props) => {
  const { phieuBenhAn } = useBenhAnContext();
  const PHIEU_DICH_VU = [
    LOAI_BENH_AN.PHIEU_XET_NGHIEM,
    LOAI_BENH_AN.PHIEU_CHAN_DOAN_HINH_ANH,
    LOAI_BENH_AN.PHIEU_CHUYEN_KHOA,
    LOAI_BENH_AN.DON_THUOC,
    LOAI_BENH_AN.VAT_TU,
    LOAI_BENH_AN.DICH_VU_KHAC,
    LOAI_BENH_AN.PHIEU_KHAM_BENH,
  ];

  const additionalConfig = useMemo(() => {
    try {
      return parseJSON(phieuBenhAn?.attributes?.additionalConfiguration) || {};
    } catch {
      return {};
    }
  }, [phieuBenhAn?.attributes?.additionalConfiguration]);
  const { componentName } = additionalConfig;

  const FormComponent = useMemo(() => ComponentMapper[componentName], [componentName]);
  const FormListComponent = useMemo(() => ComponentTypeListMapper[componentName], [componentName]);

  const RenderMap: any = {
    [COMPONENT_TYPE.COMPONENT]: FormComponent,
    // [COMPONENT_TYPE.LIST]: FormListComponent,
    [COMPONENT_TYPE.FILE]: PhieuTemplate,
    [COMPONENT_TYPE.FORM]: PhieuTemplate,
    [COMPONENT_TYPE.TAB]: PhieuTemplate,
  };

  const renderComponent = () => {
    if (!phieuBenhAn?.attributes?.renderType) return <></>;
    const ComponentToRender = RenderMap[phieuBenhAn.attributes.renderType as keyof typeof RenderMap];
    return ComponentToRender ? <ComponentToRender disabled={disabled} /> : <></>;
  };

  return (
    <div
      className={clsx('h-100 bg-white ', {
        'inner-form-generate': !PHIEU_DICH_VU.includes(componentName),
      })}
    >
      {renderComponent()}
    </div>
  );
};

export default ThongTinBenhAn;
